import { styled } from '@mui/material/styles';
import { UICheckBox } from "components/UIForm";

export const ShipmentCheckBox = styled(UICheckBox)`
    width: 18px;
    height: 18px;
`;